import type { CacheResolverMap } from 'apollo-cache-inmemory';

import { expVal } from '@confluence/feature-experiments';

export const cacheRedirects: CacheResolverMap = {
	Query: {
		singleContent(_, { id }, { getCacheKey }) {
			return getCacheKey({
				__typename: 'Content',
				id,
			});
		},
		onboardingState(_, { key }, { getCacheKey }) {
			if (!expVal('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) {
				return;
			}

			const keys = Array.isArray(key) ? key : [key];
			return keys.map((k: string) => {
				return getCacheKey({
					__typename: 'OnboardingState',
					key: k,
				});
			});
		},
	},
};
